<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="componenteNumericoSubtipoIdLocale"
          dense
          outlined
          validate-on-blur
          item-text="nome"
          item-value="id"
          label="Subtipo do componente:"
          :loading="isGetComponenteNumericoSubtiposLoading"
          :filled="!isComponenteNovo"
          :disabled="!isComponenteNovo"
          :items="componenteNumericoSubtipos"
          :append-icon="icons.mdiShapePlus"
          :rules="[validators.select]"
          @change="updateComponenteSubtipoId"
        />
      </v-col>
    </v-row>

    <v-row v-if="componenteNumericoSubtipoIdLocale">
      <v-col cols="12">
        <v-text-field
          :value="subtipoExampleValue"
          dense
          outlined
          readonly
          label="Exemplo de input válido para esse subtipo:"
          :append-icon="icons.mdiCheckDecagram"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiShapePlus, mdiCheckDecagram } from '@mdi/js'
import { computed, onMounted, ref, watchEffect } from '@vue/composition-api'
import { select } from '@core/utils/validation'
import FormularioService from '@/services/modules/FormularioService'
import ComponenteNumericoSubtiposEnum from '@/models/entities/formulario/componente/ComponenteNumericoSubtiposEnum'
import { getDataAtualNoFormatoLocaleDateString, getHorarioLocalAtualComApenasHorasEMinutos } from '@/utils/dateTime'

export default {
  props: {
    componenteNumericoSubtipoId: {
      type: Number,
      default: null,
    },
    isComponenteNovo: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const componenteNumericoSubtipoIdLocale = ref(0)
    watchEffect(() => { if (props.componenteNumericoSubtipoId) { componenteNumericoSubtipoIdLocale.value = props.componenteNumericoSubtipoId } })

    const componenteNumericoSubtipos = ref([])
    const isGetComponenteNumericoSubtiposLoading = ref(false)

    async function getComponenteNumericoSubtipos() {
      try {
        isGetComponenteNumericoSubtiposLoading.value = true
        componenteNumericoSubtipos.value = await FormularioService.getComponenteNumericoSubtipos()
      } finally {
        isGetComponenteNumericoSubtiposLoading.value = false
      }
    }
    onMounted(getComponenteNumericoSubtipos)

    function updateComponenteSubtipoId(val) { emit('update:componente-numerico-subtipo-id', val) }

    const subtipoExampleValue = computed(() => {
      switch (componenteNumericoSubtipoIdLocale.value) {
        case ComponenteNumericoSubtiposEnum.DataId:
          return getDataAtualNoFormatoLocaleDateString()
        case ComponenteNumericoSubtiposEnum.MoedaId:
          return '30,70'
        case ComponenteNumericoSubtiposEnum.HorarioId:
          return getHorarioLocalAtualComApenasHorasEMinutos()
        case ComponenteNumericoSubtiposEnum.CepId:
          return '00000-000'
        case ComponenteNumericoSubtiposEnum.CpfId:
          return '111.222.333-44'
        case ComponenteNumericoSubtiposEnum.CnpjId:
          return '11.222.333/4444-55'
        case ComponenteNumericoSubtiposEnum.TelefoneId:
          return '(11) 92222-3333'
        case ComponenteNumericoSubtiposEnum.NumeroSimplesId:
          return '99'
        default:
          return ''
      }
    })

    return {
      componenteNumericoSubtipoIdLocale,
      componenteNumericoSubtipos,
      isGetComponenteNumericoSubtiposLoading,
      updateComponenteSubtipoId,
      subtipoExampleValue,
      icons: { mdiShapePlus, mdiCheckDecagram },
      validators: { select },
    }
  },
}
</script>
